import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Icon, Button, Menu} from '@ann/web-components';
import {
  ChatInputWrapper,
  InputField,
  ActionsContainer,
  MenuWrapper,
  MenuContainer,
} from './ChatInput.styled';

const ChatInput = ({
  value = '',
  onChange,
  onSend,
  placeholder = 'Type your instructions here...',
  disabled = false,
}) => {
  const inputRef = useRef(null);
  const menuRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (value.trim() && !disabled) {
          onSend?.(value);
        }
      }
    },
    [value, disabled, onSend]
  );

  const handleSend = useCallback(() => {
    if (value.trim() && !disabled) {
      onSend?.(value);
    }
  }, [value, disabled, onSend]);

  const handleAttachment = useCallback(() => {
    setShowMenu(!showMenu);
  }, [showMenu]);

  // Cerrar menú al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Auto-resize textarea
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 120)}px`;
    }
  }, [value]);

  return (
    <ChatInputWrapper>     
            
      <InputField
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        rows={1}
      />
      <ActionsContainer>
        <MenuWrapper ref={menuRef}>
        {showMenu && (
            <MenuContainer>
              <Menu minWidth="150px" icon={true}>
                <Menu.Item id="Create Note" title='Create Note' icon='stickyNote2'/>
                <Menu.Item id="Attach file" title='Attach file' icon='filePresent'/>
                <Menu.Item id="Send EMail" title='Send EMail' icon='email'/>
              </Menu>
            </MenuContainer>
          )}
          <Button onClick={handleAttachment} pill={true} type="secondary" icon="plus" size="small"/>
         
        </MenuWrapper>
        <Button onClick={handleSend} pill={true} type="primary" icon="arrowUp" size="small"/>    
      </ActionsContainer>
    </ChatInputWrapper>
  );
};

export default ChatInput;

